import { render, staticRenderFns } from "./CustomerTerms.vue?vue&type=template&id=78566e9c&scoped=true&"
import script from "./CustomerTerms.vue?vue&type=script&lang=js&"
export * from "./CustomerTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78566e9c",
  null
  
)

export default component.exports